// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2-Jh4","header":"Messages_header__30CV7"};